import React from 'react';
import { navigate } from '@/app/navigation';

export function Link({
  href,
  children,
  className,
  onClick,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a
      href={href}
      className={className}
      {...props}
      onClick={(e) => {
        e.preventDefault();
        onClick?.(e);
        if (href) navigate(href);
      }}
    >
      {children}
    </a>
  );
}
